export const formatAccountSelectOptions = (options = []) => {
    return options.map((item) => ({
        label: (item.name || '[NO NAME]') + ' ID ' + item.trading_account.split('TA-').reverse()[0],
        value: item.trading_account,
        data: item,
    }))
}